import { fromJS } from 'immutable';

import { ApiDashboard,UserToken } from '../../../helper/HelperAuth'
import {GetHomeInteractiveSummary} from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'


export default (senderId, year, month, start, end, type=null) => async (dispatch, getState) => {

    const Authorization = UserToken;

    const url = ApiDashboard + 'interactive-summary';

    var query = {
        "sender": senderId,
        "tahun": year,
        "bulan" : month,
        "tanggal-mulai" : start,
        "tanggal-selesai":end

    };

    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
            'template-type':type,

        },
        body : JSON.stringify(query)
    };
    const response = await doFetch(url,argument);
    var data = fromJS({});
    var formVal = fromJS({})
    if (response.ok) {
        data = fromJS(await response.json());
        data = data.get('interactive-summary');
        formVal = data
        var queue = data.get('queue-tickets') == undefined ? "0" : data.get('queue-tickets')
        formVal = formVal.set('queue-tickets',queue)
        data = formVal
    }
    dispatch({ type: GetHomeInteractiveSummary, data: fromJS(data) });
};